// DE drafted — queued for native review. Site change register.
//
// R-309 (backend D-152) — a change is the ACT it performs: installation |
// replacement | repair_swap, over four phases. The ITIL vocabulary that used to
// lead this module (computed risk, CAB, conflict-checked scheduling, the PIR gate)
// is dormant overlay machinery and its strings render only where it is on.
export const siteChanges = {
  tabIncidents: { de: 'Incidents', en: 'Incidents' },
  tabChanges: { de: 'Changes', en: 'Changes' },
  // R-253 (user-directed 2026-09-22): the change list vs. the calendar/freeze
  // pair, as tabs — so a growing table never pushes the calendar out of reach.
  tabChangeList: { de: 'Liste', en: 'List' },
  tabChangeCalendar: { de: 'Kalender', en: 'Calendar' },

  statOpen: { de: 'Offene Changes', en: 'Open changes' },
  statHighRisk: { de: 'Hohes Risiko', en: 'High risk' },
  statInWindow: { de: 'Im Fenster', en: 'In window' },
  showAll: { de: 'Alle anzeigen', en: 'Show all' },
  showOpen: { de: 'Nur offene', en: 'Open only' },

  colNumber: { de: 'Nummer', en: 'Number' },
  colTitle: { de: 'Titel', en: 'Title' },
  // R-236 follow-up (user-directed 2026-09-21): the list's merged number+title
  // column — parity with the Incident list's "Incident" column.
  colChange: { de: 'Change', en: 'Change' },
  colType: { de: 'Typ', en: 'Type' },
  colRisk: { de: 'Risiko', en: 'Risk' },
  colStatus: { de: 'Status', en: 'Status' },
  colWindow: { de: 'Fenster', en: 'Window' },
  colSite: { de: 'Standort', en: 'Site' },
  colUpdated: { de: 'Aktualisiert', en: 'Updated' },

  riskHint: {
    de: 'Risiko wird aus CI-Kritikalität × Impact berechnet — nie gewählt.',
    en: 'Risk is computed from CI criticality × impact — never chosen.',
  },

  create: { de: 'Change anlegen', en: 'New change' },
  createSubmit: { de: 'Anlegen', en: 'Create' },
  cancel: { de: 'Abbrechen', en: 'Cancel' },
  fieldType: { de: 'Change-Typ', en: 'Change type' },
  fieldTitle: { de: 'Titel', en: 'Title' },
  fieldDescription: { de: 'Beschreibung', en: 'Description' },
  fieldJustification: { de: 'Begründung', en: 'Justification' },
  fieldImpact: { de: 'Impact', en: 'Impact' },
  fieldAsset: { de: 'Betroffenes Asset (CI)', en: 'Affected asset (CI)' },
  fieldReplacement: { de: 'Ersatz-Asset (optional)', en: 'Replacement asset (optional)' },
  fieldReplacementHint: {
    de: 'Beim erfolgreichen Abschluss wird das betroffene Asset stillgelegt und dieses an seiner Position bereitgestellt (CMDB-Update).',
    en: 'On successful close the affected asset is retired and this one is deployed in its place (CMDB update).',
  },
  fieldLocation: { de: 'Standort', en: 'Location' },
  selectLocation: { de: '— Standort wählen —', en: '— select location —' },
  calendarTitle: { de: 'Kalender — nächste 14 Tage', en: 'Calendar — next 14 days' },
  calSectionTitle: { de: 'Change-Kalender', en: 'Change calendar' },
  viewWeek: { de: 'Woche', en: 'Week' },
  viewAgenda: { de: 'Agenda', en: 'Agenda' },
  legendChange: { de: 'Change', en: 'Change' },
  legendFreeze: { de: 'Freeze', en: 'Freeze' },
  legendMaint: { de: 'Wartungsfenster', en: 'Maintenance window' },
  detailTitle: { de: 'Change-Details', en: 'Change detail' },
  freezeEntry: { de: 'Freeze-Fenster', en: 'Freeze window' },
  freezeBadge: { de: 'FREEZE', en: 'FREEZE' },
  changeBadge: { de: 'CHANGE', en: 'CHANGE' },
  calEmptyTitle: { de: 'Nichts in den nächsten 14 Tagen', en: 'Nothing in the next 14 days' },
  calEmptyMsg: {
    de: 'Kein geplanter Change und kein Freeze-Fenster in diesem Zeitraum.',
    en: 'No scheduled change and no freeze window fall in this window.',
  },
  fieldTemplate: { de: 'Vorlage', en: 'Template' },
  templateNone: { de: 'Ohne Vorlage', en: 'No template' },
  templateHint: {
    de: 'Typ, Pläne und Risiko-Untergrenze kommen aus der Vorlage.',
    en: 'Type, plans and the risk floor come from the template.',
  },
  fieldImplPlan: { de: 'Umsetzungsplan', en: 'Implementation plan' },
  fieldBackout: { de: 'Backout-Plan (Pflicht vor Einreichen)', en: 'Backout plan (required before submit)' },
  fieldGroup: { de: 'Zuständige Gruppe', en: 'Assignment group' },
  fieldIncident: { de: 'Verknüpfter Incident', en: 'Linked incident' },

  // R-309: the submit target is `pending_approval` — there is no `assess`.
  submit: { de: 'Zur Freigabe einreichen', en: 'Submit for approval' },
  // R-236 follow-up (user-directed 2026-09-21): mirrors the backend's own
  // refusal message (`plan_guard::plan_is_complete`, gateway-local's
  // `site_changes_view.rs`) as a pre-emptive tooltip instead of a post-submit
  // error.
  submitMissing: {
    de: 'Dieser Plan ist noch nicht fertig — füllen Sie {fields} aus, bevor Sie ihn zur Freigabe einreichen.',
    en: 'This plan is not finished — fill in {fields} before submitting it for approval.',
  },
  toAuthorize: { de: 'Zur Freigabe', en: 'To authorize' },
  schedule: { de: 'Einplanen', en: 'Schedule' },
  startImplement: { de: 'Umsetzung starten', en: 'Start implementation' },
  toReview: { de: 'Zum Review (PIR)', en: 'To review (PIR)' },
  close: { de: 'Abschließen', en: 'Close' },
  reject: { de: 'Ablehnen', en: 'Reject' },
  backOut: { de: 'Backout', en: 'Back out' },
  overrideConflicts: { de: 'Konflikte übersteuern und einplanen', en: 'Override conflicts and schedule' },

  windowStart: { de: 'Fenster-Beginn', en: 'Window start' },
  windowEnd: { de: 'Fenster-Ende', en: 'Window end' },
  setWindow: { de: 'Fenster setzen', en: 'Set window' },
  pirPh: { de: 'PIR-Notiz (Pflicht zum Abschluss)…', en: 'PIR note (required to close)…' },
  savePir: { de: 'PIR speichern', en: 'Save PIR' },

  // ── Closure code on close (R-142) ──
  closureCode: { de: 'Abschluss-Code', en: 'Closure code' },
  closureComplete: { de: 'Vollständig', en: 'Complete' },
  closureIncomplete: { de: 'Unvollständig', en: 'Incomplete' },
  closureUnsuccessful: { de: 'Nicht erfolgreich', en: 'Unsuccessful' },

  // ── Change tasks / CTASKs (R-142) ──
  tasksTitle: { de: 'Change-Aufgaben (CTASKs)', en: 'Change tasks (CTASKs)' },
  taskSeq: { de: 'Nr.', en: 'Seq' },
  taskActivity: { de: 'Tätigkeit', en: 'Activity' },
  taskSkill: { de: 'Qualifikation', en: 'Skill' },
  taskStatus: { de: 'Status', en: 'Status' },
  taskStart: { de: 'Starten', en: 'Start' },
  taskComplete: { de: 'Abschließen', en: 'Complete' },
  taskCompletedVia: { de: 'Abgeschlossen über', en: 'Completed via' },
  taskNotePh: { de: 'Abschlussnotiz (optional)…', en: 'Completion note (optional)…' },
  taskBlocked: {
    de: 'Wartet auf die vorherige Aufgabe.',
    en: 'Waiting on the earlier task.',
  },
  taskAddActivityPh: { de: 'Neue Aufgabe hinzufügen…', en: 'Add a change task…' },
  taskAdd: { de: 'Aufgabe hinzufügen', en: 'Add task' },
  tasksEmpty: { de: 'Noch keine Change-Aufgaben.', en: 'No change tasks yet.' },

  // ── ECAB verbal (emergency changes, R-142) ──
  ecabTitle: { de: 'ECAB-Freigabe (mündlich)', en: 'ECAB verbal approval' },
  ecabHint: {
    de: 'Notfall-Changes brauchen eine mündliche ECAB-Freigabe vor der Umsetzung.',
    en: 'Emergency changes need a verbal ECAB approval before implementation.',
  },
  ecabApprovedBy: { de: 'Freigegeben von', en: 'Approved by' },
  ecabNotePh: { de: 'Notiz (optional)…', en: 'Note (optional)…' },
  ecabRecord: { de: 'ECAB-Freigabe erfassen', en: 'Record ECAB approval' },
  ecabRecorded: { de: 'ECAB-Freigabe erfasst', en: 'ECAB approval recorded' },

  // R-309: the panel is APPROVALS. "CAB" is one shape the chain may take (a
  // template-raised change facing a panel), not the name of the section — and on a
  // plain act-shaped change there is no CAB at all.
  approvals: { de: 'Freigaben', en: 'Approvals' },
  // R-309 follow-up (user-directed 2026-09-21): a distinct title for the
  // legacy ITIL CAB panel's own card — it sits in the same Approvals tab as
  // the modern chain panel, so both cards saying "Approvals" would be an
  // unlabelled duplicate rather than two different things.
  legacyApprovalsTitle: { de: 'CAB-Freigaben', en: 'CAB approvals' },
  approve: { de: 'Freigeben', en: 'Approve' },
  rejectDecision: { de: 'Ablehnen', en: 'Reject' },
  addApprover: { de: 'CAB-Panel setzen (aktueller Benutzer)', en: 'Set CAB panel (current user)' },
  noApprovals: {
    de: 'Kein Freigabe-Panel — Standard-Changes aus Vorlage gelten als vorab freigegeben.',
    en: 'No approval chain yet — it is fixed when the change is submitted.',
  },

  // ── R-246: the shared approval chain ──────────────────────────────────────
  // Before submit this panel is a FORECAST of what the rules as they stand would
  // produce; after submit it is the record. The chip says which, because
  // "Level 1 — Omar Aziz" means something different on each side of that line.
  chainPreview: { de: 'Vorschau', en: 'preview' },
  chainFixed: { de: 'bei Einreichung festgelegt', en: 'chain fixed at submit' },
  chainLevel: { de: 'Stufe {level}', en: 'Level {level}' },
  // ⚠ THE CASE THIS PANEL EXISTS FOR: no change rule matches, so nobody is routed.
  // Silence here reads as "fine". Two wordings, because the answer differs on each
  // side of submit — before it, the requester can still get a rule written; after
  // it, the change is sitting there needing a human to authorise it by hand.
  //
  // ⚠⚠ This deliberately does NOT say "auto-approved", which is what it used to
  // say. Submitting a change no rule matches leaves it at `pending_approval` on
  // purpose — auto-approving would delete the Approve phase from every installation
  // that has not configured rules yet, which is the default state.
  chainNoRule: {
    de: 'Keine Change-Regel greift — es wird niemand zur Freigabe geroutet, und dieser Change muss von Hand freigegeben werden.',
    en: 'No change rule matches — nobody will be routed for approval, and this change will need authorising by hand.',
  },
  chainNoRuleHint: {
    de: 'Eine Catch-all-Regel auf Stufe 1 für Changes verhindert das.',
    en: 'Keep a level-1 catch-all rule for change requests.',
  },
  // Shown when the chain is settled but did not authorise the record, to somebody
  // who cannot authorise it either. Names the permission rather than a person,
  // because there may be no person — that is the whole situation.
  needsManualApproval: {
    de: 'Die Freigabekette ist abgeschlossen, hat diesen Change aber nicht freigegeben. Er muss von einer Person mit Change-Freigabeberechtigung von Hand freigegeben werden.',
    en: 'The approval chain has settled without approving this change. Someone with change-approval permission has to authorise it by hand.',
  },
  chainUnrouted: {
    de: 'Keine Regel hat diesen Change geroutet. Er wartet auf eine Person mit Change-Freigabeberechtigung, die ihn von Hand freigibt — es steht in keiner Warteschlange.',
    en: "No rule routed this change. It is waiting on someone with change-approval permission to authorise it by hand — it is in nobody's queue.",
  },
  chainSkippedSelf: {
    de: 'Übersprungen — Sie haben diesen Change eingereicht.',
    en: 'Skipped — you raised this change.',
  },
  chainUnknownApprover: { de: 'unbekannter Freigeber', en: 'unknown approver' },
  // Shown to everyone who is NOT the open approver, in place of a control they
  // cannot use. An empty action rail reads as a broken screen.
  waitingOnApprover: {
    de: 'Wartet auf die Freigabe von {who}. Nur diese Person kann diesen Change weiterbewegen — die Entscheidung bewegt den Datensatz, nicht ein Button hier.',
    en: 'Waiting on {who} to approve. Only they can move this change on — the decision is what moves the record, not a button here.',
  },
  chainState_waiting: { de: 'wartet', en: 'waiting' },
  chainState_pending: { de: 'offen', en: 'pending' },
  chainState_approved: { de: 'freigegeben', en: 'approved' },
  chainState_rejected: { de: 'abgelehnt', en: 'rejected' },
  chainState_skipped_self: { de: 'selbst übersprungen', en: 'skipped (self)' },
  chainState_not_required: { de: 'nicht erforderlich', en: 'not required' },
  chainState_preview: { de: 'Vorschau', en: 'preview' },

  comment: { de: 'Kommentieren', en: 'Comment' },
  commentPh: { de: 'Arbeitsnotiz…', en: 'Work note…' },

  freezeWindows: { de: 'Freeze-Fenster', en: 'Freeze windows' },
  freezeWindowsHint: {
    de: 'Sperrt Auto-Incidents für diesen Zeitraum — geplante Changes sind davon nicht betroffen.',
    en: 'Suppresses auto-raised incidents for this window — scheduled changes are unaffected.',
  },
  freezeReason: { de: 'Grund', en: 'Reason' },
  freezeReasonPh: {
    de: 'z. B. Dachwartung, jährliche Brandschutzübung',
    en: 'e.g. Roof maintenance, annual fire drill',
  },
  freezeStarts: { de: 'Beginnt', en: 'Starts' },
  freezeEnds: { de: 'Endet', en: 'Ends' },
  freezeAdd: { de: 'Freeze-Fenster anlegen', en: 'Add freeze window' },
  freezeDelete: { de: 'Löschen', en: 'Delete' },
  freezeNone: { de: 'Kein Freeze-Fenster geplant.', en: 'No freeze window scheduled.' },

  emptyTitle: { de: 'Keine Changes', en: 'No changes' },
  emptyMsg: { de: 'Noch keine geplanten Arbeiten erfasst.', en: 'No planned work recorded yet.' },
  loadError: { de: 'Changes konnten nicht geladen werden', en: 'Could not load changes' },

  // R-309 — the description says what a change IS now. The old copy led with
  // computed risk and CAB, which is the machinery a change may OPTIONALLY carry,
  // not the thing the screen is for.
  pageDescLocalChanges: {
    de: 'Ein Change bewegt eine vorhandene Einheit, mit einer Freigabe davor. Planen → freigeben → ausführen → abgeschlossen. Nur die Ausführung schreibt den Bestand — und erst, wenn die Arbeit vor Ort bestätigt ist.',
    en: 'A change moves an asset that already exists, with an authorisation step in front of it. Plan → approve → execute → closed. The execute step is the only thing here that writes asset state, and it writes it when the work is confirmed on site — not when the change is approved.',
  },
  workLogTitle: { de: 'Verlauf', en: 'Work log' },
  pageDescCloudChanges: {
    de: 'Flottenweite Change-Übersicht (nur Lesen) — Betrieb passiert an den Standorten.',
    en: 'Fleet-wide change view (read-only) — operation happens at the sites.',
  },
  freezeDeleteTitle: { de: 'Freeze-Fenster „{reason}“ löschen?', en: 'Delete freeze window “{reason}”?' },
  freezeDeleteMsg: {
    de: 'Die Unterdrückung endet sofort — Auto-Incidents für diesen Bereich werden wieder ausgelöst.',
    en: 'Suppression ends immediately — auto-incidents for its scope will raise again.',
  },

  // L-5: source template on the change detail.
  templateRefLabel: { de: 'Vorlage', en: 'Template' },
  // K-8 / L-8: incident linkage.
  raisedFromIncidentChip: { de: 'Aus Incident erstellt', en: 'Raised from incident' },
  evidenceFromIncident: {
    de: 'Nachweise werden vom auslösenden Incident gelesen, nicht hier kopiert — es gibt einen Satz Fotos, nicht zwei. Zum Ergänzen den Incident öffnen.',
    en: 'Evidence is read from the incident that raised this change, not copied here — there is one set of photographs, not two. Add to it on the incident.',
  },
  // R-309 follow-up (user-directed 2026-09-21): the record's tab strip. The
  // other five tabs reuse an existing title key (`planPanelTitle`/
  // `halvesTitle`/`tasksTitle`/`approvals`/`activityTitle`) rather than
  // duplicating the translation.
  closureTabTitle: { de: 'Abschluss', en: 'Closure' },
  evidenceTabTitle: { de: 'Nachweise', en: 'Evidence' },
  // ── R-244: the record PAGE ────────────────────────────────────────────────
  backToChanges: { de: '← Alle Changes', en: '← All changes' },
  recordMissingTitle: { de: 'Change nicht gefunden', en: 'Change not found' },
  recordMissingMsg: {
    de: 'Dieser Datensatz existiert nicht mehr. Zurück zur Liste.',
    en: 'That record no longer exists. Back to the list.',
  },
  createFromIncident: { de: 'Aus Incident INC {id}', en: 'From incident INC {id}' },

  // ── R-238: the two halves of a change ──
  halvesTitle: { de: 'Physische Arbeit', en: 'Physical work' },
  // ⚠ R-238 §6 — this string used to end "No order is enforced", which D-145 made
  // false and which sat two lines above a half labelled "Blocked — removal first".
  // Found by opening the screen; no test could have caught a sentence.
  //
  // The independence claim is still TRUE and still worth making — the halves carry
  // their own technician, timestamp and placement, and may be days apart. What is no
  // longer true is that the ORDER is free, and only on a replacement.
  halvesHint: {
    de: 'Die Hälften werden EINZELN bestätigt und können Tage auseinanderliegen — der Ausbau am Dienstag, der Einbau am Donnerstag, jeweils von der Person, die es getan hat. Bei einem Austausch muss die alte Einheit zuerst heraus: beide teilen sich denselben Platz.',
    en: 'Each half is confirmed INDEPENDENTLY and they may be days apart — the removal on Tuesday, the install on Thursday, each by whoever did the work. On a replacement the old unit must come out first: the two are a swap in one spot.',
  },
  halvesLoadError: { de: 'Hälften konnten nicht geladen werden:', en: 'Could not load the halves:' },
  halfInstall: { de: 'Einbau', en: 'Install' },
  halfRemoval: { de: 'Ausbau', en: 'Removal' },
  halfAddInstall: { de: '+ Einbau planen', en: '+ Plan the install' },
  halfAddRemoval: { de: '+ Ausbau planen', en: '+ Plan the removal' },
  // §22 — dropping a planned half is a real edit to the change's plan, not a
  // no-op undo; nothing has moved yet, but the plan itself is gone.
  halfRemoveConfirmMsg: {
    de: 'Der geplante {kind} wird aus diesem Change entfernt.',
    en: 'The planned {kind} will be removed from this change.',
  },
  halfInstallHint: {
    de: 'Die neue Einheit kommt aus dem Lager. Ab der Terminierung wird sie reserviert, damit keine zweite Änderung dieselbe Kiste beansprucht.',
    en: 'The new unit comes from stock. From scheduling onward it is reserved, so a second change cannot claim the same box.',
  },
  halfRemovalHint: {
    de: 'Die Einheit, die herauskommt. Was mit ihr geschieht, entscheidet die Technikerin bei der Bestätigung — nicht die Planung.',
    en: 'The unit that comes out. What becomes of it is decided by the technician at confirmation, not by the plan.',
  },
  halfNoAssetYet: { de: 'noch keine Einheit gewählt', en: 'no unit picked yet' },
  halfPickUnit: { de: 'Einheit wählen…', en: 'Pick the unit…' },
  halfDecideLater: { de: '— später entscheiden', en: '— decide later' },
  halfWhereTo: { de: 'Wohin', en: 'Where it goes' },
  halfPickPlace: { de: 'Ort wählen…', en: 'Pick the place…' },
  halfKeepPlanned: { de: '— wie geplant', en: '— as planned' },
  halfOutcome: { de: 'Was wird daraus', en: 'What becomes of it' },
  halfOutcomeHint: {
    de: 'Eine echte Wahl: behalten und reparieren, als brauchbar zurück ins Lager, oder verschrottet.',
    en: 'A real choice: kept for repair, back to stock as serviceable, or scrapped.',
  },
  halfPickOutcome: { de: 'Ergebnis wählen…', en: 'Pick the outcome…' },
  outcome_in_maintenance: { de: 'In Wartung — zur Reparatur', en: 'In maintenance — sent for repair' },
  outcome_in_stock: { de: 'Zurück ins Lager — noch brauchbar', en: 'Return to stock — still serviceable' },
  outcome_discarded: { de: 'Verschrottet — endgültig', en: 'Discarded — terminal' },
  halfConfirm: { de: 'Bestätigen', en: 'Confirm' },
  halfConfirmHint: {
    de: 'Bestätigen heißt: die Arbeit ist getan. Das bewegt die Einheit im Register und schreibt eine Zeile ins Bewegungsjournal.',
    en: 'Confirming means the work is done. It moves the unit in the register and writes a row to the movement ledger.',
  },
  confirmInstallTitle: { de: 'Einbau bestätigen', en: 'Confirm the install' },
  confirmRemovalTitle: { de: 'Ausbau bestätigen', en: 'Confirm the removal' },
  halfConfirmedBy: { de: 'Bestätigt von {who} am {when}', en: 'Confirmed by {who} on {when}' },
  halfNote: { de: 'Notiz', en: 'Note' },
  halfStockroomHint: {
    de: 'Lagerseitige Zustände gehören in einen Lagerort.',
    en: 'Stock-side states belong in a stockroom.',
  },
  halfPlaceMismatch: {
    de: 'Dieser Ort passt nicht zum Zustand: eine Einheit in Betrieb kann nicht im Lager stehen, Lagerbestand nicht in einem Raum.',
    en: 'That place does not match the state: a unit in service cannot sit in a stockroom, and stock cannot sit in a room.',
  },
  // R-238 §5 M1/M3/M4/M5 — the confirm dialog, brought to the prototype.
  halfVerify: { de: 'Einheit prüfen', en: 'Verify the unit' },
  halfVerifyHint: {
    de: 'Erwartet: {tag}. Scannen oder eintippen — ohne Prüfung kann nicht bestätigt werden.',
    en: 'Expected {tag}. Scan it or type it — you cannot confirm without verifying.',
  },
  halfScanMismatch: { de: 'Das ist nicht {tag}', en: 'That tag is not {tag}' },
  // ⚠ Verification is REQUIRED since 2026-09-15 — the ledger had confirmations recorded
  // "without verifying", which is the register asserting a move nobody checked.
  halfVerifyRequired: {
    de: 'Einheit prüfen, bevor bestätigt wird — Tag scannen oder eintippen.',
    en: 'Verify the unit before confirming — scan the tag or type it.',
  },
  // The plan already said where it goes; the technician confirms, not redirects.
  halfWhereToFixed: {
    de: 'Im genehmigten Änderungsplan festgelegt — hier nicht änderbar.',
    en: 'Set by the approved change — not changeable here.',
  },
  halfFrom: { de: 'Aktuell:', en: 'Currently:' },
  halfNowhere: { de: 'ohne Ort', en: 'no place recorded' },
  halfNoUnit: { de: 'keine Einheit', en: 'no unit' },
  halfOutcomeHint_repair: {
    de: 'Ihre Entscheidung, nicht die des Anforderers. Dies ist ein Reparaturtausch, daher als „zur Reparatur" vorbelegt.',
    en: 'Your call, not the requester’s. This is a repair swap, so it is defaulted to going out for repair.',
  },
  halfOutcomeHint_eol: {
    de: 'Ihre Entscheidung, nicht die des Anforderers. Dies ist ein Austausch am Lebensende, daher als „verschrottet" vorbelegt.',
    en: 'Your call, not the requester’s. This is an end-of-life change, so it is defaulted to being scrapped.',
  },
  halfDiscardedKeepsPlace: {
    de: 'Nicht gefragt — eine verschrottete Einheit behält ihren Ort, damit das Register weiterhin beantwortet, wo sie bei der Verschrottung stand.',
    en: 'Not asked — a discarded unit keeps the placement it had, so the register still answers “where was it when we scrapped it”.',
  },
  // R-238 §5 M7 — the before → after summary.
  baTitle: { de: 'Was diese Änderung bewirkt', en: 'What this change will do' },
  baComputed: { de: 'aus dem Plan berechnet', en: 'computed from the plan' },
  baBefore: { de: 'Vorher', en: 'Before' },
  baAfter: { de: 'Nachher', en: 'After' },
  baNowhere: { de: 'ohne Ort', en: 'no place recorded' },
  baPickUnits: { de: 'Einheiten oben wählen.', en: 'Pick the units above.' },
  baPending: {
    de: 'wird bei der Ausführung von der Technikerin oder dem Techniker festgelegt',
    en: 'set by the technician at execution',
  },
  baFootnote: {
    de: 'Nichts davon wird geschrieben, bevor die Arbeit bestätigt ist. Die Freigabe reserviert nur die neue Einheit.',
    en: 'Nothing here is written until a technician confirms the work. Approval only reserves the new unit.',
  },
  halfVerified: { de: 'Einheit geprüft', en: 'unit verified' },
  halfUnverified: { de: 'ohne Prüfung bestätigt', en: 'confirmed without verifying' },
  halfAssign: { de: 'Zuweisen', en: 'Assign' },
  halvesDerivedOnApproval: {
    de: 'Noch keine Hälften. Die Freigabe erzeugt sie aus dem Plan — der neuen Einheit, der zu ersetzenden und dem Einbauort — und reserviert das Ersatzteil.',
    en: 'No halves yet. Approval builds them from the plan — the new unit, the one being replaced and where it goes — and reserves the spare.',
  },
  halvesNoneAfterApproval: {
    de: '⚠ Keine Hälften: diese Änderung benennt keine Einheit, die bewegt wird, also schreibt sie nichts ins Register.',
    en: '⚠ No halves — this change names no unit to move, so it will write nothing to the register.',
  },
  // §6 C3 — the install waits for the removal, said before the click.
  halfBlockedRemovalFirst: { de: 'Blockiert — zuerst ausbauen', en: 'Blocked — removal first' },
  halfBlockedWhy: {
    de: '{tag} muss heraus, bevor die neue Einheit hinein kann — es ist ein Tausch am selben Platz, nicht zwei unabhängige Bewegungen.',
    en: '{tag} has to come out before the new unit can go in — they are a swap in the same spot, not two independent moves.',
  },
  // §6 C4 — the honest-failure path, and its two very different outcomes.
  halfCouldNotComplete: { de: 'Nicht durchführbar', en: 'Could not complete' },
  halfFailed: { de: 'Nicht durchgeführt', en: 'Could not complete' },
  failTitle: { de: 'Nicht durchführbar melden', en: 'Report could not complete' },
  failWhat: { de: 'Was hat Sie aufgehalten', en: 'What stopped you' },
  failWhatHint: {
    de: 'Die nächste Person liest das zuerst — und bei einem unvollständigen Abschluss ist es der Nachbetrachtungseintrag.',
    en: 'The next person reads this first — and on an incomplete close it becomes the post-implementation record.',
  },
  failPlaceholder: {
    de: 'z. B. Ersatzgerät defekt geliefert; falsche Halterung; kein Zutritt',
    en: 'e.g. replacement unit dead on arrival; wrong bracket; no site access',
  },
  failReturnsToPlan: {
    de: 'Es wurde noch nichts ausgeführt: die Änderung geht zurück in die Planung, die Reservierung wird freigegeben, die Freigabekette verworfen — und beide Einheiten bleiben unverändert.',
    en: 'Nothing has been applied yet, so this change goes back to plan: the reservation is released, the approval chain is wiped, and both units are left exactly as they are.',
  },
  failClosesIncomplete: {
    de: '⚠ Die andere Hälfte ist bereits bestätigt und kann nicht rückgängig gemacht werden — sie ist passiert, und das Bewegungsjournal ist fortschreibend. Diese Änderung wird daher als „unvollständig" geschlossen; was offen bleibt, braucht eine neue Änderung.',
    en: '⚠ The other half is already confirmed and cannot be undone — it happened, and the movement ledger is append-only. This change will close as incomplete; whatever is still outstanding needs a new change.',
  },
  failSubmit: { de: 'Nicht durchführbar melden', en: 'Report could not complete' },
  // §5 M15 — the diagnosis at the moment of raising, captured on the incident.
  fieldDiagnosis: { de: 'Diagnose zu diesem Zeitpunkt', en: 'Diagnosis at the time' },
  fieldDiagnosisHint: {
    de: 'Was jetzt als Ursache verstanden wird. Wird einmalig auf der Störung festgehalten und danach nicht mehr geändert — es ist der Kenntnisstand von jetzt, kein laufender Kommentar.',
    en: 'What is understood to be wrong right now. Recorded once on the incident and never edited afterwards — it is what was understood then, not a running commentary.',
  },
  fieldDiagnosisPh: {
    de: 'z. B. Kompressor fest — Lagergeräusch beim Anlauf',
    en: 'e.g. compressor seized — bearing noise on start',
  },
  halvesReserved: { de: 'Ersatzteil reserviert', en: 'Spare reserved' },
  halvesRelease: { de: 'Reservierung freigeben', en: 'Release the hold' },
  halfSavePlan: { de: 'Planen', en: 'Save plan' },
  // R-238 §5 M12 — the record says where it is in its life.
  stepperLabel: { de: 'Fortschritt der Änderung', en: 'Change progress' },
  // R-309 (backend D-152) — FOUR phases replace the seven ITIL steps. The old
  // `step_*` keys are gone with the states they named; nothing renders them.
  phase_plan: { de: 'Planung', en: 'Plan' },
  phase_approve: { de: 'Freigabe', en: 'Approve' },
  phase_execute: { de: 'Ausführung', en: 'Execute' },
  phase_closed: { de: 'Abgeschlossen', en: 'Closed' },

  // R-309 — the ACT. The record's title, and the first thing on the plan.
  act_installation: { de: 'Erstinstallation', en: 'First installation' },
  act_replacement: { de: 'Austausch am Lebensende', en: 'End-of-life replacement' },
  act_repair_swap: { de: 'Reparatur-Tausch', en: 'Repair swap' },

  domain_farm: { de: 'Farm', en: 'Farm' },
  domain_office: { de: 'Büro', en: 'Office' },
  pickOne: { de: '— auswählen —', en: '— select —' },

  // R-309 — the plan panel.
  approveAndReserve: { de: 'Freigeben (reserviert die Einheit)', en: 'Approve (reserves the unit)' },
  sendBack: { de: 'Zurück an den Antragsteller', en: 'Send back' },
  cancelChange: { de: 'Change abbrechen', en: 'Cancel change' },
  // §22 — a change past Plan is a real, acted-on record; cancelling it is
  // permanent (only Discard, Plan-only, is reversible in spirit — nothing was
  // filled in yet — and even that transition cannot be undone once posted).
  cancelChangeConfirmMsg: {
    de: 'Diese Änderung wird abgebrochen und kann nicht fortgesetzt werden.',
    en: 'This change will be cancelled and cannot be resumed.',
  },
  discardConfirmMsg: {
    de: 'Dieser Plan wird verworfen und kann nicht fortgesetzt werden.',
    en: 'This plan will be discarded and cannot be resumed.',
  },

  discard: { de: 'Verwerfen', en: 'Discard' },

  // R-309 — the info note the prototype opens the Plan phase with. It explains the
  // one rule a reader cannot infer from the form: why the fields lock, and why a
  // send-back unlocks them without anything being "unlocked".
  planNote: {
    de: 'Alles unten ist bearbeitbar, solange dieser Change in **Plan** ist. Das Einreichen sperrt diese Zeilen und öffnet die nächste Phase — und ein von der Freigabe zurückgeschickter Change entsperrt sie wieder, weil sich die Bearbeitbarkeit aus der AKTUELLEN Phase ergibt und nicht auf dem Datensatz gespeichert ist.',
    en: 'Everything below is editable while this change is in **Plan**. Submitting locks these rows and opens the next phase — and a change sent back by an approver unlocks them again, because what is editable is read off the CURRENT phase rather than stored on the record.',
  },

  // R-309 — the activity log reads as sentences, never as a payload dump.
  activityTitle: { de: 'Aktivität', en: 'Activity' },
  // R-309 follow-up (user-directed 2026-09-21): parity with the Incident
  // record page's own Activity card, which carries this same tag.
  appendOnlyTag: { de: 'nur anhängend', en: 'append-only' },
  ev_created: { de: 'Change erstellt', en: 'Change raised' },
  ev_status: { de: 'Weitergeschaltet auf {to}', en: 'Moved to {to}' },
  ev_statusPlain: { de: 'Status geändert', en: 'Status changed' },
  ev_updated: { de: 'Plan geändert — {fields}', en: 'Plan edited — {fields}' },
  ev_updatedPlain: { de: 'Datensatz geändert', en: 'Record edited' },
  ev_reserved: { de: 'Einheit reserviert', en: 'Incoming unit reserved' },
  ev_released: { de: 'Reservierung freigegeben', en: 'Reservation released' },
  ev_halvesDerived: { de: 'Hälften aus dem Plan erzeugt', en: 'Halves built from the plan' },
  ev_confirmed: { de: 'Arbeit vor Ort bestätigt', en: 'Work confirmed on site' },
  ev_conflictOverride: { de: 'Terminkonflikt bewusst übergangen', en: 'Schedule conflict overridden' },
  ev_comment: { de: 'Kommentar', en: 'Comment' },

  state_plan: { de: 'Plan', en: 'Plan' },
  state_pending_approval: { de: 'Wartet auf Freigabe', en: 'Pending approval' },
  state_approved: { de: 'Freigegeben', en: 'Approved' },
  state_in_progress: { de: 'In Ausführung', en: 'In progress' },
  state_closed: { de: 'Abgeschlossen', en: 'Closed' },
  state_cancelled: { de: 'Abgebrochen', en: 'Cancelled' },

  sendBackReason: { de: 'Warum wird es zurückgeschickt?', en: 'Why is it going back?' },
  sendBackHint: {
    de: 'Die antragstellende Person liest das — sie muss wissen, was zu ändern ist. Der Change kehrt bearbeitbar in die Planungsphase zurück.',
    en: 'The requester reads this — they have to know what to change. The change returns to an editable Plan.',
  },
  sendBackPh: {
    de: 'z. B. Zeitfenster kollidiert mit einer Wartung — bitte neu planen',
    en: 'e.g. window collides with maintenance — please replan',
  },

  planPanelTitle: { de: 'Plan', en: 'Plan' },
  planEditable: { de: 'bearbeitbar', en: 'editable' },
  planLocked: { de: 'gesperrt — Phase {phase}', en: 'locked — {phase} phase' },
  planSaveFailed: { de: 'Änderung konnte nicht gespeichert werden', en: 'That change could not be saved' },
  plan_change_type: { de: 'Art der Änderung', en: 'Change type' },
  plan_change_type_hint: {
    de: 'Ein Austausch ist eine Installation mit einer Ausbau-Hälfte. Der Wechsel auf Erstinstallation entfernt sie.',
    en: 'A replacement is an installation with a removal half attached. Switching to first installation drops it.',
  },
  plan_site_code: { de: 'Standort', en: 'Site' },
  plan_site_code_hint: {
    de: 'Bestimmt die Domäne und schränkt Orte und Einheiten unten ein.',
    en: "The site's type defaults the domain, and scopes which locations and which in-service assets are offered below.",
  },
  plan_domain: { de: 'Domäne', en: 'Domain' },
  plan_domain_hint: {
    de: 'Aus dem Standort vorbelegt, überschreibbar. Freigaberegeln können darauf eingeschränkt sein.',
    en: 'Defaulted from the site, overridable. Approval rules can be scoped by it.',
  },
  plan_new_asset_id: { de: 'Einzubauende Einheit', en: 'New asset to install' },
  plan_new_asset_hint: {
    de: 'Die konkrete Einheit, kein Modell — sie wird bei der Freigabe reserviert. Nur Einheiten auf Lager.',
    en: 'The exact unit, not a model — this is what gets reserved on approval so nobody else can claim it. Only assets currently in stock are listed.',
  },
  plan_target_location_code: { de: 'Einbauort', en: 'Install at' },
  plan_target_hint: {
    de: 'Ein Ort innerhalb des Standorts — niemals ein Lager: eingebaute Einheiten stehen an Orten.',
    en: 'A location inside the site — a room, hall or area. Never a warehouse: installed units live at locations.',
  },
  plan_old_asset_id: { de: 'Zu ersetzende Einheit', en: 'Asset being replaced' },
  plan_old_asset_hint: {
    de: 'Was mit ihr geschieht — Reparatur, zurück ins Lager oder Verschrottung — entscheidet die Technikerin bei der Ausführung, nicht Sie.',
    en: "In-service units at this site. What happens to it — repair, back to stock, or discarded — is the technician's decision at execution, not yours.",
  },
  plan_planned_date: { de: 'Geplantes Datum', en: 'Planned date' },
  plan_planned_date_hint: {
    de: 'Wann die Arbeit erwartet wird. Nur in der Zukunft — die Hälften werden bestätigt, wenn sie tatsächlich geschehen.',
    en: 'When the work is expected. Forward-only — the halves are confirmed when they actually happen.',
  },
  plan_reason: { de: 'Grund für die Änderung', en: 'Reason for the change' },
  plan_reason_hint: {
    de: 'Warum wird das gemacht? Die freigebende Person liest das zuerst.',
    en: 'Why is this being done? The approver reads this first.',
  },
  plan_reason_ph: {
    de: 'z. B. Sensor fällt wiederholt aus — Ersatzeinheit erforderlich',
    en: 'e.g. sensor keeps failing — replacement unit required',
  },

  // R-309 — BEFORE → AFTER, computed from the plan and never stored.
  beforeAfterTitle: { de: 'Was diese Änderung bewirkt', en: 'What this change will do' },
  beforeAfterDerived: { de: 'aus dem Plan berechnet', en: 'computed from the plan' },
  beforeAfterEmpty: { de: 'Einheiten oben auswählen.', en: 'Pick the assets above.' },
  beforeAfterFooter: {
    de: 'Hier wird nichts geschrieben, bis eine Technikerin die Arbeit bestätigt. Die Freigabe reserviert nur die neue Einheit.',
    en: 'Nothing here is written until a technician confirms the work. Approval only reserves the new unit.',
  },
  before: { de: 'VORHER', en: 'BEFORE' },
  after: { de: 'NACHHER', en: 'AFTER' },
  afterTechnicianDecides: {
    de: 'von der Technikerin bei der Ausführung festgelegt',
    en: 'set by the technician at execution',
  },
  inStore: { de: 'im Lager', en: 'in store' },
  colHalves: { de: 'Hälften', en: 'Halves' },
  // R-238 §5 M10 — the three columns the prototype's list has and ours did not.
  colNewAsset: { de: 'Neue Einheit', en: 'New asset' },
  colInstallAt: { de: 'Einbauort', en: 'Install at' },
  colRaisedBy: { de: 'Erstellt von', en: 'Raised by' },
  fromIncident: { de: 'aus Störung', en: 'from incident' },
  fromP1Incident: { de: 'aus offener P1', en: 'from open P1' },
  // §5 M16 — the raise-gate, stated rather than left as a dead button.
  notReady: {
    de: 'Eine NEUE Änderung kann gerade nicht erstellt werden — dafür fehlt {missing}. Bestehende Änderungen sind davon nicht betroffen und werden weiterhin angezeigt.',
    en: 'A NEW change cannot be raised right now — that needs {missing}. Existing changes are unaffected and still listed below.',
  },
  needsSpare: { de: 'mindestens eine Einheit im Lagerbestand', en: 'at least one asset in stock to install' },
  halvesProgress: { de: '{done} von {total} bestätigt', en: '{done} of {total} confirmed' },
  // R-238 §6 C2 — approval now DERIVES the halves from the plan, so an empty set
  // before approval is "not planned yet" rather than a gap somebody forgot; after
  // approval it means the change names no units to move at all.
  halvesNotPlanned: { de: 'noch nicht geplant', en: 'not planned yet' },
  waitingOnYou: { de: 'Wartet auf dich', en: 'Waiting on you' },
  yourTurn: { de: 'Du bist dran', en: 'Your turn' },

  // Toasts — raised per call site (`shared/write-toast.ts`), so each one can say
  // exactly what happened to which change rather than a generic "updated".
  toastChangeCreated: { de: '{n} angelegt', en: '{n} created' },
  toastChangeSubmitted: { de: '{n} zur Freigabe eingereicht', en: '{n} submitted for approval' },
  toastChangeApprovalRecorded: { de: 'Freigabe für {n} erfasst', en: 'Approval recorded for {n}' },
  toastChangeApproved: { de: '{n} freigegeben', en: '{n} approved' },
  toastChangeSentBack: { de: '{n} zurück in die Planung', en: '{n} sent back to Plan' },
  toastChangeStarted: { de: 'Umsetzung von {n} begonnen', en: 'Work started on {n}' },
  toastChangeDiscarded: { de: '{n} verworfen', en: '{n} discarded' },
  toastChangeCancelled: { de: '{n} abgebrochen', en: '{n} cancelled' },
  toastChangeClosed: { de: '{n} abgeschlossen', en: '{n} closed' },
  toastPirSaved: { de: 'Abschlussbericht gespeichert', en: 'Review note saved' },
  toastApproverAdded: { de: 'Genehmiger hinzugefügt', en: 'Approver added' },
  toastCabApproved: { de: 'CAB-Freigabe für {n} erfasst', en: 'CAB approval recorded for {n}' },
  toastCabRejected: { de: 'CAB-Ablehnung für {n} erfasst', en: 'CAB rejection recorded for {n}' },
  toastEcabRecorded: { de: 'ECAB-Genehmigung erfasst', en: 'ECAB approval recorded' },
  toastTaskAdded: { de: 'Aufgabe hinzugefügt', en: 'Task added' },
  toastTaskStarted: { de: 'Aufgabe begonnen', en: 'Task started' },
  toastTaskCompleted: { de: 'Aufgabe abgeschlossen', en: 'Task completed' },
  toastCommentAdded: { de: 'Kommentar hinzugefügt', en: 'Comment added' },
  toastFreezeWindowCreated: { de: 'Sperrfenster angelegt', en: 'Freeze window created' },
  toastFreezeWindowDeleted: { de: 'Sperrfenster gelöscht', en: 'Freeze window deleted' },
  toastHalfPlanned: { de: 'Arbeitsschritt geplant', en: 'Work step planned' },
  toastHalfRemoved: { de: 'Geplanter Arbeitsschritt entfernt', en: 'Planned work step removed' },
  toastInstallConfirmed: { de: 'Einbau von {tag} bestätigt', en: 'Installation of {tag} confirmed' },
  toastRemovalConfirmed: { de: 'Ausbau von {tag} bestätigt', en: 'Removal of {tag} confirmed' },
  toastReservationReleased: { de: 'Reservierung freigegeben', en: 'Reservation released' },
  toastHalfFailed: { de: 'Fehlschlag erfasst', en: 'Failure recorded' },
  // Confirm dialogs for the one-click acts that undo someone else's decision.
  sendBackConfirmMsg: {
    de: '{n} geht zurück in die Planung und alle Felder werden wieder bearbeitbar.',
    en: '{n} goes back to Plan and every field becomes editable again.',
  },
  sendBackApprovedConfirmMsg: {
    de: '{n} ist bereits freigegeben. Zurück in die Planung hebt die Freigabe auf — sie muss erneut erteilt werden.',
    en: '{n} is already approved. Sending it back to Plan withdraws that approval — it will need approving again.',
  },
  overrideConflictsConfirmMsg: {
    de: '{n} überschneidet sich mit einem Sperrfenster oder einer anderen Änderung. Trotzdem freigeben?',
    en: '{n} clashes with a freeze window or another change. Approve it anyway?',
  },
  cabRejectConfirmMsg: {
    de: 'Ihre Ablehnung von {n} wird im CAB-Protokoll erfasst.',
    en: 'Your rejection of {n} will be recorded on the CAB log.',
  },
  releaseConfirmMsg: {
    de: 'Die für diese Änderung reservierte Einheit wird freigegeben und kann anderweitig verwendet werden.',
    en: 'The unit held for this change is released and can be taken for other work.',
  },
} as const;
